import { useEffect, useState } from 'react';
import { checkBrowser } from 'config/browserCheck';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Contract, ethers, formatUnits, toBigInt } from 'ethers';
import { CheckMetaMaskConnectError } from 'config/errorCheck';
import abi from 'config/abi';
import {
  HAVAH_RPC_URL,
  NftContractAddress,
  POLYGON_RPC_URI,
  PolygonContractAddress,
  seasonStatus,
} from 'config/config';
import {
  setAddress,
  setBalance,
  setConnected,
  setKind,
} from 'redux/slice/walletSlice';
import {
  setAmount,
  setPrice,
  setSaleId,
  setSoldOut,
  setTotalAmount,
  setTotalAmountUpdateSaleId,
  setWei,
} from 'redux/slice/saleSlice';
import IconService, { CallBuilder, HttpProvider } from 'icon-sdk-js';
import axios from 'axios';
import genesisBoxListImg from 'asset/image/genesis_box_list.png';
import { useBodyScrollLock } from 'components/reveal/modal/useBodyScrollLock';

import HeaderNav from 'components/Nav/HeaderNav';
import MainPage from './MainPage';
import Footer from 'components/Footer/Footer';
import EventBanner from 'components/modal/notification/EventBanner';
import SalePage from 'components/Sale/SalePage';
import ClassificationPage from 'components/Classification/ClassificationPage';
import FAQPage from 'components/FAQ/FAQPage';
import MintLottieModal from 'components/modal/MintLottieModal';
import { saleAPI } from 'api/saleAPI';
import Web3 from 'web3';

const GenesisSaleMain = (props) => {
  const { t } = useTranslation();

  const httpProvider = new HttpProvider(HAVAH_RPC_URL);
  const iconService = new IconService(httpProvider);

  const { lockScroll, openScroll } = useBodyScrollLock();

  const dispatch = useDispatch();
  const address = useSelector((state) => state.walletSlice.address);
  const saleId = useSelector((state) => state.saleSlice.saleId);
  const wei = useSelector((state) => state.saleSlice.wei);
  const totalAmount = useSelector((state) => state.saleSlice.totalAmount);
  const totalAmountUpdated = useSelector(
    (state) => state.saleSlice.totalAmountUpdated,
  );
  const totalAmountUpdateSaleId = useSelector(
    (state) => state.saleSlice.totalAmountUpdateSaleId,
  );

  const [title, setTitle] = useState('STARTS IN');
  const [day, setDay] = useState('00');
  const [hour, setHour] = useState('00');
  const [min, setMin] = useState('00');
  const [sec, setSec] = useState('00');
  const [saleStart, setSaleStart] = useState('');
  const [isContarctSaleStatus, setIsContarctSaleStatus] = useState(false);
  const [exMarketSoldOut, setExMarketSoldOut] = useState({
    Havah: false,
    Pala: false,
    Altava: false,
    Hyper: false,
    Tmon: false,
  });
  const [saleStatus, setSaleStatus] = useState(seasonStatus);
  const [nftList, setNftList] = useState([]);
  const [walletSigner, setSigner] = useState(undefined);
  const [completeList, setCompleteList] = useState([]);
  const [isServerSaleStatus, setIsServerSaleStatus] = useState(false);

  const [mintLottieModalOpen, setMintLottieModalOpen] = useState('');
  const [eventBannerOpen, setEventBannerOpen] = useState('open');

  const [clientSec, setclientSec] = useState(0);

  const connectWallet = async (kind) => {
    if (isMobile) {
      window.location.href = '/genesissale/mobile';
      return false;
    } else {
      if (!checkBrowser()) {
        return false;
      }
    }

    if (kind === 'metamask') {
      if (
        exMarketSoldOut['Tmon'] === null ||
        exMarketSoldOut['Tmon'] === undefined
      ) {
        alert(t('ENDSALE_POPUP'));
        return false;
      }

      let signer = null;
      let tempProvider;
      let netId;
      let netName;

      if (window.ethereum === null || window.ethereum === undefined) {
        window.open(
          'https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn',
        );
      } else {
        // Connect to the MetaMask EIP-1193 object. This is a standard
        // protocol that allows Ethers access to make all read-only
        // requests through MetaMask.
        tempProvider = new ethers.BrowserProvider(window.ethereum);

        await tempProvider.getNetwork().then(async (net) => {
          netId = net.chainId.toString();
          netName = net.name;
        });

        // polygon mainNet 137 , matic
        if (netId !== '137' && netName !== 'matic') {
          // 폴리곤 메인넷이 아닐경우
          // 폴리곤 네트워크로 변경
          try {
            await window.ethereum.request({
              method: 'wallet_switchEthereumChain',
              params: [{ chainId: '0x89' }],
            });
          } catch (switchError) {
            // This error code indicates that the chain has not been added to MetaMask.
            if (switchError.code === 4902) {
              try {
                await window.ethereum.request({
                  method: 'wallet_addEthereumChain',
                  params: [
                    {
                      chainId: '0x89',
                      rpcUrls: ['https://polygon-rpc.com/'],
                      chainName: 'Matic Mainnet',
                      nativeCurrency: {
                        name: 'MATIC',
                        symbol: 'MATIC',
                        decimals: 18,
                      },
                      blockExplorerUrls: ['https://explorer.matic.network'],
                    },
                  ],
                });
              } catch (addError) {
                // handle "add" error
              }
            }
            // handle other "switch" errors
          }
        }

        try {
          await tempProvider.send('eth_requestAccounts', []);
        } catch (e) {
          if (e.error.code !== 4001) {
            alert(t(CheckMetaMaskConnectError(e.error.code)));
          }
        }

        // It also provides an opportunity to request access to write
        // operations, which will be performed by the private key
        // that MetaMask manages for the user.
        signer = await tempProvider.getSigner();
        let tokenAddress;
        let usdtBalance;
        // 메타마스크 지갑 주소
        await signer.getAddress().then(async (result) => {
          tokenAddress = result;

          // Polygonscan
          // Matic address
          // 0x0000000000000000000000000000000000001010
          const a = {
            address: '0x0000000000000000000000000000000000001010',
            abi: [
              'function balanceOf(address a) view returns (uint)',
              'function approve(address a, uint256 b) view returns (bool)',
            ],
          };

          const contract = new Contract(a.address, abi, signer);
          const balance = await contract.balanceOf(tokenAddress);

          usdtBalance = formatUnits(balance, 18);
        });

        // setSigner(signer);

        if (saleId !== '') {
          // alert(t("RETRY_POPUP"));
          // return false;
          if (!saleId.toLowerCase().includes('pub')) {
            await getSaleAddress(saleId, tokenAddress, signer);
          }
          await checkMintable(saleId, tokenAddress, signer);
        }
        dispatch(setAddress(tokenAddress));
        dispatch(setBalance(usdtBalance));
        dispatch(setKind('metamask'));
        dispatch(setConnected(true));
      }
    } else if (kind === 'havah') {
      const revealDateStr = saleStatus.saleScheduleTime.REVEAL_START;
      const revealDate = new Date(revealDateStr);

      const revealTime = revealDate.getTime();
      const curTime = new Date().getTime();

      if (curTime < revealTime) {
        alert(t('NOTREVEAL_POPUP'));
        return false;
      }

      if (!window.havah) {
        //alert('havah is uninstalled!');
        window.open(
          'https://chrome.google.com/webstore/detail/havah-wallet/cnncmdhjacpkmjmkcafchppbnpnhdmon',
        );
      } else {
        let provider = window.havah;

        if (provider !== undefined) {
          provider
            .connect()
            .then(async (result) => {
              dispatch(setAddress(result.body.address));
              dispatch(setBalance('0.0'));
              dispatch(setKind('havah'));
              dispatch(setConnected(true));

              await getNFTList(result.body.address);
            })
            .catch((error) => console.error(`Error: ${error}`));
        }
      }
    }
  };

  const getSaleAddress = async (sale, address, signer) => {
    //console.log("getSaleAddress start :", sale, address, signer);
    if (sale !== '' && address !== '' && signer !== undefined) {
      const testContract = new Contract(PolygonContractAddress, abi, signer);
      const getSaleAddressFunc = testContract.getFunction('getSaleAddress');
      await getSaleAddressFunc(sale, address)
        .then((res) => {
          //
        })
        .catch((e) => {
          console.log(e);
          alert(t('NONOGNWL_POPUP'));
        });
    }
  };
  const checkMintable = async (sale, address, signer) => {
    //console.log("checkMintable start :", sale, address, signer);
    if (sale !== '' && address !== '' && signer !== undefined) {
      const testContract = new Contract(PolygonContractAddress, abi, signer);
      const mintAbleFunc = testContract.getFunction('mintable');
      let purchases;
      await mintAbleFunc(sale, address)
        .then((res) => {
          purchases = res.toString();
        })
        .catch((e) => {
          //alert(t('NONOGNWL_POPUP'));
        });

      //console.log("checkMintable end 구매가능갯수 :", purchases);
      dispatch(setAmount(purchases));
    }
  };

  const getNFTList = async (val) => {
    // 지갑 검증 api 사용해야되는 부분

    const balanceCall = new CallBuilder()
      .to(NftContractAddress)
      .method('balanceOf')
      .params({ _owner: val })
      .build();

    const res = await iconService.call(balanceCall).execute();

    const nftCount = Number(res);

    if (nftCount >= 1) {
      const nfts = [];
      for (let i = 0; i < res; i += 1) {
        if (Number(i) < 0 || Number(i) >= nftCount) {
          throw new Error('Invalid index');
        }

        const getNftId = new CallBuilder()
          .to(NftContractAddress)
          .method('tokenOfOwnerByIndex')
          .params({
            _owner: val,
            _index: '' + i,
          })
          .build();
        const nftId = await iconService.call(getNftId).execute();

        const getNftURI = new CallBuilder()
          .to(NftContractAddress)
          .method('tokenURI')
          .params({ _tokenId: nftId })
          .build();

        const nftURI = await iconService.call(getNftURI).execute();

        const nftMetadata = await getNftUseURI(nftURI);

        if (nftMetadata !== false) {
          const nft = nftMetadata.data;
          //console.log(nft);
          nft.isApproved = await checkNftAprroved(nftId);

          const nftAttributes = nft.attributes;

          nft.id = Number(nftId);
          nft.tokenId = nftId;
          let revealed = false;
          for (const nftAttributesKey in nftAttributes) {
            const trait_type = nftAttributes[nftAttributesKey]['trait_type'];
            const value = nftAttributes[nftAttributesKey]['value'];

            // 리빌 된 상태에서는 Vehicle Grade 로 읽어야됨.
            if (trait_type === 'Vehicle Grade') {
              nft.rarity = value;
              revealed = true;
            }

            if (trait_type === 'Vehicle Type') {
              nft.kind = value;
            }
          }
          if (!revealed) {
            nft.image = genesisBoxListImg;
          }
          nft.isRevealed = revealed;
          nfts.push(nft);
        }
      }

      setNftList(nfts);
    }
  };

  const getNftUseURI = async (uri) => {
    let result;
    await axios
      .get(uri)
      .then((r) => {
        result = r;
        //console.log(r);
      })
      .catch((error) => {
        console.log(error);
        result = false;
      });
    return result;
  };

  const checkNftAprroved = async (tokenId) => {
    const nftIsRevealed = new CallBuilder()
      .to(NftContractAddress)
      .method('isRevealed')
      .params({ _tokenId: tokenId })
      .build();

    const isRevealed = await iconService.call(nftIsRevealed).execute();

    return isRevealed === '0x1';
  };

  const funcMint = async (boxCnt) => {
    if (saleId === '') return;

    if (address === '') {
      // 지갑 연결 로직 주소가 없으면
      alert(t('CONNECT_POPUP'));
      await connectWallet('metamask');
      return;
    }
    // 민트 로직 진행
    const result = await mint(boxCnt);
    alert(result);
    await checkMintable(saleId, address, walletSigner);
    handleMintLottieClose();
  };

  const mint = async (boxCnt) => {
    handleMintLottieOpen();
    try {
      console.log('mint start');
      let success = 0;
      let fail = 0;

      const testContract = new Contract(
        PolygonContractAddress,
        abi,
        walletSigner,
      );
      const exchangeFunc = testContract.getFunction('exchange');
      const weiAmount = toBigInt(wei);

      for (let i = 0; i < boxCnt; i++) {
        try {
          const res = await exchangeFunc(saleId, { value: weiAmount });
          const receipt = await res.wait();
          if (receipt.status === 1) {
            success++;
          } else if (receipt.status === 0) {
            fail++;
          }
        } catch (error) {
          console.log(error);
          fail++;
        }
      }
      console.log('mint end');
      return t('SUCCEED_POPUP', { success: success, fail: fail });
    } catch (e) {
      return t('FAIL_POPUP');
    }
  };
  const setTime = () => {
    const curDate = new Date();
    const ogStartTime = new Date(saleStatus.saleScheduleTime.OG_SALE_START);
    const ogEndTime = new Date(saleStatus.saleScheduleTime.OG_SALE_END);
    const wlStartTime = new Date(saleStatus.saleScheduleTime.WL_SALE_START);
    const wlEndTime = new Date(saleStatus.saleScheduleTime.WL_SALE_END);
    const publicStartTime = new Date(
      saleStatus.saleScheduleTime.PUBLIC_SALE_START,
    );

    let curTitle = '';
    let compareDate = ogStartTime;
    let tempList = [];
    let tempSoldOut;
    let tempPrice;
    let tempSaleId;

    if (
      exMarketSoldOut['Tmon'] === null ||
      exMarketSoldOut['Tmon'] === undefined
    ) {
      tempList.push('PUBLIC');
    }

    if (curDate < ogStartTime) {
      // og sale 시작전
      curTitle = saleStatus.saleScheduleTitle.OG_SALE_START;
      compareDate = ogStartTime;
    } else if (curDate >= ogStartTime && curDate < wlStartTime) {
      // og sale 시작
      //console.log("setTime start OGSALE : ",curDate, ogStartTime, saleId);
      curTitle = saleStatus.saleScheduleTitle.OG_SALE_END;
      if (saleStatus.saleId['OG'] !== saleId) {
        console.log('setTime OGSALE ID SET');
        tempPrice = saleStatus.salePrice['OG'];
        tempSaleId = saleStatus.saleId['OG'];
      }
      // totalAmount  로 비교하지 말고 이후에 salestatus 에서 넘어오는 soldout 정보로 비교해야됨.
      compareDate = ogEndTime;

      if (totalAmount === '0' && totalAmountUpdated) {
        tempList.push('OG');
        tempSoldOut = true;

        if (curDate.getDate() === 19) {
          tempSoldOut = false;
          curTitle = saleStatus.saleScheduleTitle.WL_SALE_START;
          compareDate = wlStartTime;
        }
      }
    } else if (curDate >= wlStartTime && curDate < publicStartTime) {
      // wl sale 시작
      //console.log("setTime start WLSALE : ",curDate, ogStartTime, saleId);
      curTitle = saleStatus.saleScheduleTitle.WL_SALE_END;
      compareDate = wlEndTime;
      tempList.push('OG');

      if (saleStatus.saleId['WL'] !== saleId) {
        console.log('setTime WLSALE ID SET');
        tempPrice = saleStatus.salePrice['WL'];
        tempSaleId = saleStatus.saleId['WL'];
      }

      if (
        totalAmount === '0' &&
        totalAmountUpdated &&
        totalAmountUpdateSaleId === saleId
      ) {
        tempList.push('WL');
        tempList.push('PUBLIC');
        tempSoldOut = true;
      }
    } else if (curDate >= publicStartTime) {
      // public sale 시작
      //console.log("setTime start PUBLICSALE : ",curDate, ogStartTime, saleId);
      curTitle = saleStatus.saleScheduleTitle.PUBLIC_SALE_END;
      tempList.push('OG');
      tempList.push('WL');

      if (saleStatus.saleId['PUBLIC'] !== saleId) {
        console.log('setTime PUBLICSALE ID SET');
        tempPrice = saleStatus.salePrice['PUBLIC'];
        tempSaleId = saleStatus.saleId['PUBLIC'];
      }

      // if(totalAmount === "0" && totalAmountUpdated && totalAmountUpdateSaleId === saleId){
      if (
        exMarketSoldOut['Tmon'] &&
        totalAmountUpdated &&
        totalAmountUpdateSaleId === saleId
      ) {
        tempList.push('PUBLIC');
        tempSoldOut = true;
      }
    }

    const dayVal = 1000 * 60 * 60 * 24;
    const hourVal = dayVal / 24;
    const minuteVal = hourVal / 60;
    if (compareDate !== undefined) {
      const diffTime = compareDate.getTime() - curDate.getTime();

      const diffDay = Math.trunc(diffTime / dayVal);

      const diffHour = Math.trunc((diffTime - diffDay * dayVal) / hourVal);

      const diffMinute = Math.trunc(
        (diffTime - (diffDay * dayVal + diffHour * hourVal)) / minuteVal,
      );
      const diffSec = Math.ceil(
        (diffTime -
          (diffDay * dayVal + diffHour * hourVal + diffMinute * minuteVal)) /
          1000,
      );

      setTitle(curTitle);
      setCompleteList(tempList);
      setDay(diffDay < 10 ? '0' + diffDay : '' + diffDay);
      setHour(diffHour < 10 ? '0' + diffHour : '' + diffHour);
      setMin(diffMinute < 10 ? '0' + diffMinute : '' + diffMinute);
      setSec(diffSec < 10 ? '0' + diffSec : '' + diffSec);
    }

    if (curTitle !== saleStatus.saleScheduleTitle.OG_SALE_START) {
      setSaleStart('sale-start');
    }

    if (tempSaleId !== undefined) {
      //console.log("setTime setSaleId ", tempSaleId);
      dispatch(setSaleId(tempSaleId));
    }

    if (tempPrice !== undefined) {
      //console.log("setTime setPrice ", tempPrice);
      dispatch(setPrice(tempPrice));
    }

    if (tempSoldOut !== undefined) {
      //console.log("setTime setSoldOut ", tempSoldOut);
      dispatch(setSoldOut(tempSoldOut));
    }

    let tempSec = clientSec + 1;
    if (tempSec === 11) {
      tempSec = 1;
    }
    setclientSec(tempSec);
    console.log('setTime end : ', curDate, ogStartTime, saleId);

    //console.log(clientSec);
    if (clientSec % 5 === 0) {
      const tickSaleInfo = setTimeout(() => {
        if (isServerSaleStatus) {
          getSaleInfo().then(() => {
            clearTimeout(tickSaleInfo);
          });
        } else {
          clearTimeout(tickSaleInfo);
        }
      }, 5000);
    }
    if (clientSec % 10 === 0) {
      const tickExternalMarket = setTimeout(() => {
        getExtrebalMarketStatus().then(() => {
          clearTimeout(tickExternalMarket);
        });
      }, 10000);
    }
  };
  const getSaleInfo = async () => {
    if (isServerSaleStatus) {
      //console.log("getSaleInfo start", saleId);
      const web3 = new Web3(new Web3.providers.HttpProvider(POLYGON_RPC_URI));
      // 스마트 컨트랙트 주소
      const contract = new web3.eth.Contract(abi, PolygonContractAddress);

      if (saleId !== '') {
        const tempSaleId = saleId;
        const saleSchedules = contract.methods
          .getSaleScheduleInfo(saleId)
          .call();
        let total;
        let price;
        let wei;
        await saleSchedules.then((res) => {
          total = (res['totalAmount'] - res['exchangedCount']).toString();
          price = formatUnits(res['price'], 'ether');
          wei = res['price'].toString();
        });
        //console.log("getSaleInfo setTotalAmountUpdateSaleId");
        dispatch(setTotalAmountUpdateSaleId(tempSaleId));
        //console.log("getSaleInfo setTotalAmount");
        dispatch(setTotalAmount(total));
        dispatch(setPrice(price));
        //console.log("getSaleInfo setPrice");
        dispatch(setWei(wei));
        //console.log("getSaleInfo setWei");

        switch (saleId) {
          case saleStatus.saleId['OG']:
            saleStatus.salePrice['OG'] = price;
            break;
          case saleStatus.saleId['WL']:
            saleStatus.salePrice['WL'] = price;
            break;
          case saleStatus.saleId['PUBLIC']:
            saleStatus.salePrice['PUBLIC'] = price;
            break;
          default:
            saleStatus.salePrice['OG'] = price;
            break;
        }
      }
    }
  };

  const handleChainChanged = async () => {
    // We recommend reloading the page, unless you must do otherwise.
    //window.location.reload();
    const chainId = await window.ethereum.request({ method: 'eth_chainId' });
    // console.log("chainId", chainId);
    if (chainId !== '0x89') {
      alert(t('WRONGNETWORK_POPUP'));
      dispatch(setAddress(''));
      dispatch(setKind(''));
      dispatch(setBalance('0.0'));
      dispatch(setConnected(false));
      dispatch(setAmount('0'));
    }
  };

  const getExtrebalMarketStatus = async () => {
    try {
      //console.log("getExtrebalMarketStatus start")
      let tempSaleStatus;
      await saleAPI.externalMarketStatus().then((r) => {
        tempSaleStatus = r.data;
      });
      setExMarketSoldOut(tempSaleStatus['externalMarketStatus']);
    } catch (e) {
      console.log(e);
    }
    //console.log("getExtrebalMarketStatus end ",exMarketSoldOut)
  };
  const getServerSaleStatus = async () => {
    if (!isContarctSaleStatus) {
      try {
        let tempSaleStatus;
        console.log('getServerSaleStatus start');
        await saleAPI.seasonStatus().then((r) => {
          tempSaleStatus = r.data;
        });
        await convertStatus(tempSaleStatus);
      } catch (e) {
        console.log(e);
      }
    }
  };

  const convertStatus = async (stat) => {
    const tempSeasonStatus = stat['seasonStatus'];

    // saleId 설정
    saleStatus.saleId.OG = tempSeasonStatus['OG'];
    saleStatus.saleId.WL = tempSeasonStatus['WhiteList'];
    saleStatus.saleId.PUBLIC = tempSeasonStatus['Public'];

    setIsServerSaleStatus(true);
    console.log('getServerSaleStatus end');
    await getContarctSaleStatus();
  };
  const getContarctSaleStatus = async () => {
    console.log('getContarctSaleStatus start');
    const web3 = new Web3(new Web3.providers.HttpProvider(POLYGON_RPC_URI));
    // 스마트 컨트랙트 주소
    const contract = new web3.eth.Contract(abi, PolygonContractAddress);

    const saleIds = saleStatus.saleId;
    for (const key in saleIds) {
      const id = saleIds[key];

      if (id !== '') {
        const test = contract.methods.getSaleScheduleInfo(id).call();
        let price;
        let startDate;
        let endDate;

        await test.then((res) => {
          price = formatUnits(res['price'], 'ether');
          startDate = Number(res['startDate'].toString() + '000');
          endDate = Number(res['endDate'].toString() + '000');
        });

        switch (id) {
          case saleStatus.saleId['OG']:
            saleStatus.salePrice['OG'] = price;
            saleStatus.saleScheduleTime.OG_SALE_START = startDate;
            saleStatus.saleScheduleTime.OG_SALE_END = endDate;
            break;
          case saleStatus.saleId['WL']:
            saleStatus.salePrice['WL'] = price;
            saleStatus.saleScheduleTime.WL_SALE_START = startDate;
            saleStatus.saleScheduleTime.WL_SALE_END = endDate;
            break;
          case saleStatus.saleId['PUBLIC']:
            saleStatus.salePrice['PUBLIC'] = price;
            saleStatus.saleScheduleTime.PUBLIC_SALE_START = startDate;
            saleStatus.saleScheduleTime.PUBLIC_SALE_END = endDate;
            break;
          default:
            saleStatus.salePrice['OG'] = price;
            break;
        }
      }
    }
    setIsContarctSaleStatus(true);
    console.log('getContarctSaleStatus end');
  };

  useEffect(() => {
    //console.log("page render");
    if (window.ethereum !== null && window.ethereum !== undefined) {
      window.ethereum.removeListener('chainChanged', handleChainChanged);
      window.ethereum.on('chainChanged', handleChainChanged);
    }
    getExtrebalMarketStatus().then(() => {
      //console.log("getExtrebalMarketStatus");
    });
    getServerSaleStatus().then(() => {
      //console.log("Get Server Sale Status");
      getSaleInfo().then(() => {
        setTime();
      });
    });
  }, []);

  useEffect(() => {
    const tick = setTimeout(() => {
      setTime();
    }, 1000);

    return () => {
      clearTimeout(tick);
    };
  }, [sec]);

  const handleMintLottieOpen = () => {
    lockScroll();
    setMintLottieModalOpen('open');
  };

  const handleMintLottieClose = () => {
    openScroll();
    setMintLottieModalOpen('');
  };

  if (
    title === 'OG SALE STARTS IN' ||
    title === 'STARTS IN' ||
    exMarketSoldOut['Tmon'] === null ||
    exMarketSoldOut['Tmon'] === undefined
  ) {
    return (
      <div className="App">
        <HeaderNav walletConnectFunc={connectWallet} />
        <MainPage
          title={title}
          day={day}
          hour={hour}
          min={min}
          sec={sec}
          saleStart={saleStart}
          exMarketSoldOut={exMarketSoldOut}
          saleStatus={saleStatus}
          isRevealTime={
            exMarketSoldOut['Tmon'] === null ||
            exMarketSoldOut['Tmon'] === undefined
          }
        />
        <Footer saleStart={saleStart} />
        <EventBanner
          bannerOpen={eventBannerOpen}
          handleEventBannerClose={() => setEventBannerOpen('')}
          isRevealTime={
            exMarketSoldOut['Tmon'] === null ||
            exMarketSoldOut['Tmon'] === undefined
          }
        />
      </div>
    );
  }
  return (
    <div className="App">
      <HeaderNav walletConnectFunc={connectWallet} />
      <MainPage
        title={title}
        day={day}
        hour={hour}
        min={min}
        sec={sec}
        saleStart={saleStart}
        exMarketSoldOut={exMarketSoldOut}
        saleStatus={saleStatus}
        isRevealTime={
          exMarketSoldOut['Tmon'] === null ||
          exMarketSoldOut['Tmon'] === undefined
        }
      />

      <SalePage
        completeSchedule={completeList}
        funcMint={funcMint}
        saleStatus={saleStatus}
      />
      <ClassificationPage />
      <FAQPage />
      <Footer saleStart={saleStart} />
      <MintLottieModal open={mintLottieModalOpen} />
      <EventBanner
        bannerOpen={eventBannerOpen}
        handleEventBannerClose={() => setEventBannerOpen('')}
        isRevealTime={
          exMarketSoldOut['Tmon'] === null ||
          exMarketSoldOut['Tmon'] === undefined
        }
      />
    </div>
  );
};

export default GenesisSaleMain;
